import { createReducer, on } from '@ngrx/store';
import {
  addWorkspaceId,
  addWorkspaceQuestionnaireId,
  addWorkspaceStudyId,
  addWorkspaceTypeId,
} from '../actions/workspace.actions';

export const workspaceId = '';

export const workspaceReducers = createReducer(
  workspaceId,
  on(addWorkspaceId, (state: any, item) => (state = item.workspaceId)),
);

export const workspaceTypeId = '';
export const workspaceTypeReducers = createReducer(
  workspaceTypeId,
  on(addWorkspaceTypeId, (state: any, item) => (state = item.workspaceTypeId)),
);
export const workspaceStudyId = '';
export const workspaceStudyReducers = createReducer(
  workspaceTypeId,
  on(
    addWorkspaceStudyId,
    (state: any, item) => (state = item.workspaceStudyId),
  ),
);

export const workspaceQuestionnaireId = '';
export const workspaceQuestionnaireReducers = createReducer(
  workspaceQuestionnaireId,
  on(
    addWorkspaceQuestionnaireId,
    (state: any, item) => (state = item.workspaceQuestionnaireId),
  ),
);
